import { render } from "./HospitalEarnings.vue?vue&type=template&id=4f253cd7&ts=true"
import script from "./HospitalEarnings.vue?vue&type=script&lang=ts"
export * from "./HospitalEarnings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__